import { AstrologyCard } from "../AstrologyCard";
import { WesternAstrologyContainer } from "./style";

export const WesternAstrology = ({ zodiac, isToday, isTomorrow, isHowIs, isYearPredictionsZodiac }) => {
  
  return (
    <WesternAstrologyContainer>
      <div className="western-astrology-content">
        <AstrologyCard zodiac={zodiac} isToday={isToday} isTomorrow={isTomorrow} isHowIs={isHowIs} isYearPredictionsZodiac={isYearPredictionsZodiac}/>
      </div>
    </WesternAstrologyContainer>
  );
};
